<template>
    <div>
      <!-- <b-row class="dashboard-rentabilidad-neta" v-if="vistaTotalNegocio"> -->
      <b-row class="dashboard-rentabilidad-neta">
        <b-col cols="5">
          <app-rentabilidad-neta-semestral-total
            ref="rentabilidadNetaSemestralTotal"
            titulo="Resultado Semestral Total"
            :rentabilidadNetaItems= "rentabilidadNetaSemestralTotal"
            @consultaVentas="consultaVentas(true, true)"
            @consultaInversionesBancarias="consultaInversionesBancarias(true)"
            @consultaCompras="consultaCompras(true, true)"
            @consultaGastos="consultaGastos(true, true)"
            @consultaSueldos="consultaSueldos(true)"
            @consultaImpuestos="consultaImpuestos(true)"
            @consultaGastosBancarios="consultaGastosBancarios(true)"
            @consultaGastosBancariosPlanesPago="consultaGastosBancariosPlanesPago(true)"
            @consultaPremiosReembolsos="consultaPremiosReembolsos(true)"
            @consultaComprasReembolsos="consultaComprasReembolsos(true)"
            @consultaImpuestosBancos="consultaImpuestosBancos(true)"
            @consultaImpuestosInteresesPlanesPagosBancos="consultaInteresesPlanesPagosBancos(true)"
            @consultaImpuestosInteresesPlanesPagosPagos="consultaInteresesPlanesPagosPagos(true)"
            @consultaDeudaComercial="consultaDeudaComercial(true)"
            @consultaVentasDeudaComercial="consultaVentasDeudaComercial(true)"
            @consultaVentasDiferenciasCambio="consultaVentasDiferenciasCambio(true)"
            @consultaComprasDiferenciasCambio="consultaComprasDiferenciasCambio(true)"
            @consultaGastosHonorarios="consultaGastosHonorarios(true)">
          </app-rentabilidad-neta-semestral-total>
        </b-col>
        <b-col cols="2">
        </b-col>
        <b-col cols="5">
          <app-rentabilidad-neta-anual-total
            ref="rentabilidadNetaAnualTotal"
            titulo="Resultado Anual Total"
            :rentabilidadNetaItems= "rentabilidadNetaAnualTotal"
            @consultaVentas="consultaVentas(false, true)"
            @consultaInversionesBancarias="consultaInversionesBancarias(false)"
            @consultaCompras="consultaCompras(false, true)"
            @consultaGastos="consultaGastos(false, true)"
            @consultaSueldos="consultaSueldos(false)"
            @consultaImpuestos="consultaImpuestos(false)"
            @consultaGastosBancarios="consultaGastosBancarios(false)"
            @consultaGastosBancariosPlanesPago="consultaGastosBancariosPlanesPago(false)"
            @consultaPremiosReembolsos="consultaPremiosReembolsos(false)"
            @consultaComprasReembolsos="consultaComprasReembolsos(false)"
            @consultaImpuestosBancos="consultaImpuestosBancos(false)"
            @consultaImpuestosInteresesPlanesPagosBancos="consultaInteresesPlanesPagosBancos(false)"
            @consultaImpuestosInteresesPlanesPagosPagos="consultaInteresesPlanesPagosPagos(false)"
            @consultaDeudaComercial="consultaDeudaComercial(false)"
            @consultaVentasDeudaComercial="consultaVentasDeudaComercial(false)"
            @consultaVentasDiferenciasCambio="consultaVentasDiferenciasCambio(false)"
            @consultaComprasDiferenciasCambio="consultaComprasDiferenciasCambio(false)"
            @consultaGastosHonorarios="consultaGastosHonorarios(false)">
          </app-rentabilidad-neta-anual-total>
        </b-col>
      </b-row>

      <b-row class="dashboard-rentabilidad-neta">
        <b-col cols="5">
          <app-rentabilidad-neta-semestral
            ref="rentabilidadNetaSemestral"
            titulo="Resultado Semestral s/Reemb."
            :rentabilidadNetaItems= "rentabilidadNetaSemestral"
            @consultaVentas="consultaVentas(true, false)"
            @consultaInversionesBancarias="consultaInversionesBancarias(true)"
            @consultaCompras="consultaCompras(true, false)"
            @consultaGastos="consultaGastos(true, false)"
            @consultaSueldos="consultaSueldos(true)"
            @consultaImpuestos="consultaImpuestos(true)"
            @consultaGastosBancarios="consultaGastosBancarios(true)"
            @consultaGastosBancariosPlanesPago="consultaGastosBancariosPlanesPago(true)"
            @consultaImpuestosBancos="consultaImpuestosBancos(true)"
            @consultaImpuestosInteresesPlanesPagosBancos="consultaInteresesPlanesPagosBancos(true)"
            @consultaImpuestosInteresesPlanesPagosPagos="consultaInteresesPlanesPagosPagos(true)"
            @consultaDeudaComercial="consultaDeudaComercial(true)"
            @consultaVentasDeudaComercial="consultaVentasDeudaComercial(true)"
            @consultaVentasDiferenciasCambio="consultaVentasDiferenciasCambio(true)"
            @consultaComprasDiferenciasCambio="consultaComprasDiferenciasCambio(true)"
            @consultaGastosHonorarios="consultaGastosHonorarios(true)">
          </app-rentabilidad-neta-semestral>
        </b-col>
        <b-col cols="2">
        </b-col>
        <b-col cols="5">
          <app-rentabilidad-neta-anual
            ref="rentabilidadNetaAnual"
            titulo="Resultado Anual s/Reemb."
            :rentabilidadNetaItems= "rentabilidadNetaAnual"
            @consultaVentas="consultaVentas(false, false)"
            @consultaInversionesBancarias="consultaInversionesBancarias(false)"
            @consultaCompras="consultaCompras(false, false)"
            @consultaGastos="consultaGastos(false, false)"
            @consultaSueldos="consultaSueldos(false)"
            @consultaImpuestos="consultaImpuestos(false)"
            @consultaGastosBancarios="consultaGastosBancarios(false)"
            @consultaGastosBancariosPlanesPago="consultaGastosBancariosPlanesPago(false)"
            @consultaImpuestosBancos="consultaImpuestosBancos(false)"
            @consultaImpuestosInteresesPlanesPagosBancos="consultaInteresesPlanesPagosBancos(false)"
            @consultaImpuestosInteresesPlanesPagosPagos="consultaInteresesPlanesPagosPagos(false)"
            @consultaDeudaComercial="consultaDeudaComercial(false)"
            @consultaVentasDeudaComercial="consultaVentasDeudaComercial(false)"
            @consultaVentasDiferenciasCambio="consultaVentasDiferenciasCambio(false)"
            @consultaComprasDiferenciasCambio="consultaComprasDiferenciasCambio(false)"
            @consultaGastosHonorarios="consultaGastosHonorarios(false)">
          </app-rentabilidad-neta-anual>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import RentabilidadNetaSemestral from './RentabilidadNetaIndicador';
import RentabilidadNetaAnual from './RentabilidadNetaIndicador';
import RentabilidadNetaSemestralTotal from './RentabilidadNetaIndicador';
import RentabilidadNetaAnualTotal from './RentabilidadNetaIndicador';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  components: {
    appRentabilidadNetaSemestral: RentabilidadNetaSemestral,
    appRentabilidadNetaAnual: RentabilidadNetaAnual,
    appRentabilidadNetaSemestralTotal: RentabilidadNetaSemestralTotal,
    appRentabilidadNetaAnualTotal: RentabilidadNetaAnualTotal,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  // props: {
  //   vistaTotalNegocio: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data() {
    return {
      rentabilidadNetaSemestral: [],
      rentabilidadNetaAnual: [],
      rentabilidadNetaSemestralTotal: [],
      rentabilidadNetaAnualTotal: [],
    }
  },
  mounted () {
  },
  methods: {
    actualizarIndicadorSemestralTotal(indicador) {
      this.rentabilidadNetaSemestralTotal = [];

      this.loadArray(this.rentabilidadNetaSemestralTotal, indicador);

      this.$refs.rentabilidadNetaSemestralTotal.actualizado();
    },
    actualizarIndicadorAnualTotal(indicador) {
      this.rentabilidadNetaAnualTotal = [];

      this.loadArray(this.rentabilidadNetaAnualTotal, indicador);

      this.$refs.rentabilidadNetaAnualTotal.actualizado();
    },
    actualizarIndicadorSemestral(indicador) {
      this.rentabilidadNetaSemestral = [];

      this.loadArray(this.rentabilidadNetaSemestral, indicador);

      this.$refs.rentabilidadNetaSemestral.actualizado();
    },
    actualizarIndicadorAnual(indicador) {
      this.rentabilidadNetaAnual = [];

      this.loadArray(this.rentabilidadNetaAnual, indicador);

      this.$refs.rentabilidadNetaAnual.actualizado();
    },

    loadArray(arrayResultados, indicador) {
      let rentabilidad = indicador.cotizacionTotal - indicador.costoTotal;

      let participacionVentas = parseFloat(indicador.ventas) / parseFloat(indicador.cotizacionTotal);
      participacionVentas *= 100.00;
      let participacionVentasDiferenciaCambio = parseFloat(indicador.diferenciaCambioVentas) / parseFloat(indicador.cotizacionTotal);
      participacionVentasDiferenciaCambio *= 100.00;
      let participacionInversiones = parseFloat(indicador.inversiones) / parseFloat(indicador.cotizacionTotal);
      participacionInversiones *= 100.00;

      let participacionCompras = parseFloat(indicador.compras) / parseFloat(indicador.cotizacionTotal);
      participacionCompras *= 100.00;
      let participacionGastos = parseFloat(indicador.gastos) / parseFloat(indicador.cotizacionTotal);
      participacionGastos *= 100.00;
      let participacionSueldos = parseFloat(indicador.sueldos) / parseFloat(indicador.cotizacionTotal);
      participacionSueldos *= 100.00;
      let participacionImpuestos = parseFloat(indicador.impuestos) / parseFloat(indicador.cotizacionTotal);
      participacionImpuestos *= 100.00;
      let participacionGastosBancarios = parseFloat(indicador.gastosBancarios) / parseFloat(indicador.cotizacionTotal);
      participacionGastosBancarios *= 100.00;
      let participacionPremios = parseFloat(indicador.premiosReembolsos) / parseFloat(indicador.cotizacionTotal);
      participacionPremios *= 100.00;
      let participacionDeudaComercial = parseFloat(indicador.deudaComercial) / parseFloat(indicador.cotizacionTotal);
      participacionDeudaComercial *= 100.00;
      let participacionDiferenciaCambio = parseFloat(indicador.diferenciaCambioCompras) / parseFloat(indicador.cotizacionTotal);
      participacionDiferenciaCambio *= 100.00;

      arrayResultados.push({ 'nombre': 'fechaDesde', 'campo': 'Desde', 
          'valor': this.$options.filters.fecha(indicador.fechaDesde), 
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'fechaHasta', 'campo': 'Hasta', 
          'valor': this.$options.filters.fecha(indicador.fechaHasta),
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'pjeObjetivo', 'campo': 'Pje.Objetivo', 
          'valor': this.$options.filters.porcentaje(indicador.pjeObjetivo),
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'ventas', 'campo': 'Ventas', 
          'valor': this.$options.filters.moneda(indicador.ventas),
          'participacion': this.$options.filters.porcentaje(participacionVentas, 2)});
      arrayResultados.push({ 'nombre': 'diferenciaCambioVentas', 'campo': 'Ventas - Dif.Cambio', 
          'valor': this.$options.filters.moneda(indicador.diferenciaCambioVentas), 
          'participacion': this.$options.filters.porcentaje(participacionVentasDiferenciaCambio, 2)});
      arrayResultados.push({ 'nombre': 'inversiones', 'campo': 'Inversiones/Intereses Ganados', 
          'valor': this.$options.filters.moneda(indicador.inversiones),
          'participacion': this.$options.filters.porcentaje(participacionInversiones, 2)});
      arrayResultados.push({ 'nombre': 'cotizacionTotal', 'campo': 'Total Ingresos', 
          'valor': this.$options.filters.moneda(indicador.cotizacionTotal),
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'compras', 'campo': 'Compras', 
          'valor': this.$options.filters.moneda(indicador.compras),
          'participacion': this.$options.filters.porcentaje(participacionCompras, 2)});
      arrayResultados.push({ 'nombre': 'gastos', 'campo': 'Gastos', 
          'valor': this.$options.filters.moneda(indicador.gastos),
          'participacion': this.$options.filters.porcentaje(participacionGastos, 2)});
      arrayResultados.push({ 'nombre': 'sueldos', 'campo': 'Sueldos', 
          'valor': this.$options.filters.moneda(indicador.sueldos),
          'participacion': this.$options.filters.porcentaje(participacionSueldos, 2)});
      arrayResultados.push({ 'nombre': 'impuestos', 'campo': 'Impuestos', 
          'valor': this.$options.filters.moneda(indicador.impuestos),
          'participacion': this.$options.filters.porcentaje(participacionImpuestos, 2),
          'toolTip': 'Impuestos + Impuestos Bancos + Planes de Pago'});
      arrayResultados.push({ 'nombre': 'gastosBancarios', 'campo': 'Gastos Bcos.', 
          'valor': this.$options.filters.moneda(indicador.gastosBancarios),
          'participacion': this.$options.filters.porcentaje(participacionGastosBancarios, 2)});

      if (!(/true/i).test(indicador.sinReembolsos)) {
        arrayResultados.push({ 'nombre': 'premiosReembolsos', 'campo': 'Premios/Reembolsos', 
          'valor': this.$options.filters.moneda(indicador.premiosReembolsos),
          'participacion': this.$options.filters.porcentaje(participacionPremios, 2),
          'toolTip': 'Transferencias x Premios + Compras x Reembolsos' });

        arrayResultados.push({ 'nombre': 'deudaComercial', 'campo': 'Deuda Comercial', 
          'valor': this.$options.filters.moneda(indicador.deudaComercial),
          'participacion': this.$options.filters.porcentaje(participacionDeudaComercial, 2),
          'toolTip': 'Ventas x Reembolsos - Imputaciones de Transferencias x Premios - Compras x Reembolsos'});
      }
      arrayResultados.push({ 'nombre': 'diferenciaCambioCompras', 'campo': 'Compras - Dif.Cambio',
          'valor': this.$options.filters.moneda(indicador.diferenciaCambioCompras), 
          'participacion': this.$options.filters.porcentaje(participacionDiferenciaCambio, 2)});
      arrayResultados.push({ 'nombre': 'costoTotal', 'campo': 'Total Costos', 
          'valor': this.$options.filters.moneda(indicador.costoTotal),
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'pjeRentabilidad', 'campo': 'RN - %', 
          'valor': this.$options.filters.porcentaje(indicador.pjeRentabilidad),
          'participacion': ''});
      arrayResultados.push({ 'nombre': 'rentabilidad', 'campo': 'RN - $', 
          'valor': this.$options.filters.moneda(rentabilidad), 
          'participacion': ''});
    },

    consultaVentas(semestral, totalNegocio) {
      let params = {
        semestral,
        totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasIndicadorRentabilidadNeta', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              // { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];

            if (!totalNegocio) {
              format.push({ titulo: 'Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaCompras(semestral, totalNegocio) {
      let params = {
        semestral,
        totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasIndicadorRentabilidadNeta', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              // { titulo: 'Neto Gastos Producción', nombre: 'montoNetoCuentasProduccion', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Neto Viáticos', nombre: 'montoNetoViaticos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaComprasReembolsos(semestral) {
      let params = {
        semestral
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasReembolsosIndicadorRentabilidadNeta', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras-reembolsos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },

              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaGastos(semestral, totalNegocio) {
      let params = {
        semestral,
        totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosIndicadorRentabilidadNeta', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Gastos';
            let fileName = 'gastos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Gastos', nombre: 'montoNetoCuentasGastos', formato: '' },
              { titulo: 'Neto Ordenes Internas', nombre: 'montoNetoOrdenesProveedoresInternas', formato: '' },
              { titulo: 'Neto Remitos Internos', nombre: 'montoNetoRemitosInternos', formato: '' },

              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaSueldos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getSueldosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let sueldos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (sueldos) {
            if (sueldos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Sueldos';
            let fileName = 'sueldos';
            let format = [
              { titulo: 'Periodo', nombre: 'periodo', formato: 'fecha' },
              { titulo: 'SAC', nombre: 'sac', formato: 'bool' },
              // { titulo: 'Personal', nombre: 'personal', formato: '' },
              { titulo: 'Honorarios', nombre: 'importeHonorarios', formato: '' },
              { titulo: 'Adicional', nombre: 'importeAdicional', formato: '' },
              { titulo: 'Otros Conceptos', nombre: 'importeOtrosConceptos', formato: '' },
              { titulo: 'Liq. Final', nombre: 'importeLiquidacionFinal', formato: '' },
            ];

            this.exportXLS(title, fileName, sueldos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaInversionesBancarias(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getInversionesBancariasIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let inversionesBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (inversionesBancos) {
            if (inversionesBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Inversiones';
            let fileName = 'inversiones-bancarias';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, inversionesBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaGastosBancarios(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosBancariosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let gastosBancarios = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (gastosBancarios) {
            if (gastosBancarios.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Gastos Bancarios';
            let fileName = 'gastos-bancarios';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
              { titulo: 'Cotización', nombre: 'cotizacion', formato: '' },
              { titulo: 'Total', nombre: 'importeTotal', formato: '' },
            ];

            this.exportXLS(title, fileName, gastosBancarios, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaGastosBancariosPlanesPago(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosBancariosPlanesPagosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let gastosBancariosPlanes = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (gastosBancariosPlanes) {
            if (gastosBancariosPlanes.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Gastos Bancarios x Planes';
            let fileName = 'gastos-bancarios-planes';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Nro.Plan', nombre: 'numeroPlan', formato: '' },
              { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
              { titulo: 'Nro.Pago', nombre: 'numeroPago', formato: '' },
              { titulo: 'Nro.Cuota', nombre: 'numeroCuota', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, gastosBancariosPlanes, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaImpuestos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getImpuestosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let impuestos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (impuestos) {
            if (impuestos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Impuestos';
            let fileName = 'impuestos';
            let format = [
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Organismo', nombre: 'organismo', formato: '' },
              { titulo: 'Impuesto', nombre: 'impuesto', formato: '' },
              { titulo: 'Periodo', nombre: 'periodo', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
              { titulo: 'Importe Imputado', nombre: 'importeImputado', formato: '' },
            ];

            this.exportXLS(title, fileName, impuestos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaImpuestosBancos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getImpuestosBancosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let impuestosBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (impuestosBancos) {
            if (impuestosBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Impuestos - Bancos';
            let fileName = 'impuestos-bancos';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, impuestosBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaInteresesPlanesPagosBancos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getInteresesPlanesPagosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let interesesPlanesPagosBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (interesesPlanesPagosBancos) {
            if (interesesPlanesPagosBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Intereses - Bancos';
            let fileName = 'intereses-planes-bancos';
            let format = [
              { titulo: 'Nro.Plan', nombre: 'planPagosNumero', formato: '' },
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha Débito', nombre: 'fechaCreditoDebito', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, interesesPlanesPagosBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaInteresesPlanesPagosPagos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getInteresesPlanesPagosPagosExternosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let interesesPlanes = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (interesesPlanes) {
            if (interesesPlanes.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Intereses - Planes de Pagos';
            let fileName = 'intereses-planes-pagos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Nro.Plan', nombre: 'numeroPlan', formato: '' },
              { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
              { titulo: 'Nro.Pago', nombre: 'numeroPago', formato: '' },
              { titulo: 'Nro.Cuota', nombre: 'numeroCuota', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, interesesPlanes, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaPremiosReembolsos(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getTransferenciasPremiosIndicadorRentabilidadNeta', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let transferenciasPremios = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (transferenciasPremios) {
            if (transferenciasPremios.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Premios-Reembolsos';
            let fileName = 'premios-reembolsos';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
            ];

            this.exportXLS(title, fileName, transferenciasPremios, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaDeudaComercial(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getDeudaComercial', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let deudaComercial = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (deudaComercial) {
            if (deudaComercial.length != 0) {
              exportXls = Boolean(true);

              deudaComercial = deudaComercial.map(presupuestoInterno => ({
                ...presupuestoInterno,
                saldo: parseFloat(presupuestoInterno.importeVentas) 
                  - parseFloat(presupuestoInterno.importeTransferencias)
                  - parseFloat(presupuestoInterno.importeCompras)
              }))
            }
          }
          if (exportXls) {
            let title= 'Detalle de Deuda Comercial';
            let fileName = 'deuda-comercial';
            let format = [
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Confirmación', nombre: 'fechaConfirmacion', formato: 'fecha' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Importe Ventas', nombre: 'importeVentas', formato: '' },
              { titulo: 'Importe Transferencias', nombre: 'importeTransferencias', formato: '' },
              { titulo: 'Importe Compras', nombre: 'importeCompras', formato: '' },              
              { titulo: 'Saldo', nombre: 'saldo', formato: '' },
            ];

            this.exportXLS(title, fileName, deudaComercial, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaVentasDeudaComercial(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasDeudaComercial', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let deudaComercial = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (deudaComercial) {
            if (deudaComercial.length != 0) {
              exportXls = Boolean(true);

              deudaComercial = deudaComercial.map(presupuestoInterno => ({
                ...presupuestoInterno,
                saldo: parseFloat(presupuestoInterno.importeVentas) - parseFloat(presupuestoInterno.importeTransferencias)
              }))
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'deuda-comercial-vtas';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Tipo Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Nro Comprobante', nombre: 'numero', formato: '' },
              { titulo: 'Monto Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Monto Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' },
            ];

            this.exportXLS(title, fileName, deudaComercial, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaVentasDiferenciasCambio(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasDiferenciasCambio', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let diferenciasCambio = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (diferenciasCambio) {
            if (diferenciasCambio.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'vtas-diferencias-cambio';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Cotizacion Comprobante', nombre: 'cotizacionComprobante', formato: '' },
              { titulo: 'Fecha Cobro', nombre: 'fechaCobro', formato: 'fecha' },
              { titulo: 'Nro.Cobro', nombre: 'cobroId', formato: '' },
              { titulo: 'Importe Cobro', nombre: 'importeCobro', formato: '' },
              { titulo: 'Cotizacion Cobro', nombre: 'cotizacionCobro', formato: '' },
              { titulo: 'Dif.Cotizaciones', nombre: 'diferenciaCotizacion', formato: '' },
              { titulo: 'Dif.Cambio', nombre: 'diferenciaCambio', formato: '' },
            ];

            this.exportXLS(title, fileName, diferenciasCambio, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaComprasDiferenciasCambio(semestral) {
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasDiferenciasCambio', semestral)
        .then(() => {
          let exportXls = Boolean(false); 
          let diferenciasCambio = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (diferenciasCambio) {
            if (diferenciasCambio.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras-diferencias-cambio';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Cotizacion Comprobante', nombre: 'cotizacionComprobante', formato: '' },
              { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
              { titulo: 'Nro.Pago', nombre: 'numeroPago', formato: '' },
              { titulo: 'Importe Pago', nombre: 'importePago', formato: '' },
              { titulo: 'Cotizacion Pago', nombre: 'cotizacionPago', formato: '' },
              { titulo: 'Dif.Cotizaciones', nombre: 'diferenciaCotizacion', formato: '' },
              { titulo: 'Dif.Cambio', nombre: 'diferenciaCambio', formato: '' },
            ];

            this.exportXLS(title, fileName, diferenciasCambio, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultaGastosHonorarios(semestral) {
      let params = {
        semestral,
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosHonorariosIndicadorRentabilidadNeta', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Honorarios';
            let fileName = 'honorarios';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Honorarios', nombre: 'montoNetoCuentasHonorarios', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' },
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

  }
}
</script>

<style>
</style>


